import React from "react";
import { ChevronRight, Sparkles } from "lucide-react";
import "./styles/Home.css";
import { useNavigate } from "react-router-dom";

const Home = () => {
  let navigate = useNavigate();
  const goToForm = () => {
    navigate("/postulante");
  };
  return (
    <div className="min-h-screen bg-[#f7efef] flex justify-center items-center p-6 font-sans text-[#3a2d2c]">
      <div className="home max-w-xl w-full bg-white rounded-3xl p-10 md:p-16 shadow-lg text-center border border-white">
        <div className="home-header inline-flex items-center justify-center w-20 h-20 rounded-2xl mb-8">
          <Sparkles size={40} />
        </div>
        <p className="home-description text-xs font-bold uppercase mb-4 tracking-widest">
          RECLUTAMIENTO HRM
        </p>
        <h1 className="home-title text-4xl md:text-5xl font-extrabold leading-tight mb-6">
          ¡Bienvenido(a)!
        </h1>
        <p className="home-paragraph text-lg leading-relaxed mb-12 max-w-sm mx-auto">
          Estamos felices de tenerte aquí. Inicia tu proceso de selección
          completando tu información.
        </p>
        <button
          onClick={goToForm}
          className="home-button relative w-full py-4 px-8 rounded-xl font-bold text-lg transition-all duration-300 shadow-md flex items-center justify-center gap-2 overflow-hidden"
        >
          <span className="relative z-10">Iniciar mi registro</span>
          <ChevronRight className="relative z-10" size={22} />
          <div className="absolute inset-0 bg-black opacity-0 hover:opacity-10 transition-opacity duration-300"></div>
        </button>
        <div className="home-footer mt-12 pt-8 border-t border-[#f2e8e8]">
          <p className="home-fotter-description text-xs">
            © 2026 Talento Humano • Todos los derechos reservados
          </p>
        </div>
      </div>
    </div>
  );
};
export default Home;
